import CohortListSkeleton from "./CohortListSkeleton";
export default CohortListSkeleton;
